import React from 'react'
import { ArrowForwardIos } from '@material-ui/icons'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Radio, RadioGroup, withStyles } from '@material-ui/core'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import PropTypes from 'prop-types'
import './BarChartSettings.scss'
import { ColorPicker, Select } from '@components/common'
import Switch from '@material-ui/core/Switch'
import { SALES_COMPARABLES } from '@engine/dependencies/constants'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'
import AddBoxIcon from '@material-ui/icons/AddBox'

const useStyles = () => ({
  root: {
    '& .MuiFormControlLabel-root': {
      paddingRight: '50px',
      width: '113px',
      '& .MuiRadio-root': {
        color: '#757575'
      },
      '& .Mui-checked': {
        color: '#0066CC'
      }
    },
    '& .MuiTypography-root.MuiTypography-body1': {
      // fontFamily: '\'Roboto\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontSize: '14px',
      letterSpacing: '0.25px'
    }
  },
  expansionTitle: {
    '& .MuiExpansionPanelSummary-root.Mui-expanded': {
      marginBottom: '-30px'
    }
  }
})
export class BarChartSettings extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isOptionsPanelOpen: true,
      isCustomizeColorsPanelOpen: false,
      isLayoutPanelOpen: false,
      isExpandAll: true,
      barWidthvalue: props.barChartSettings.barWidth || 40
    }
  }

  componentDidUpdate = prevProps => {
    if ((prevProps.barChartSettings?.barWidth !== this.props.barChartSettings?.barWidth)) {
      this.setState({
        barWidthvalue: this.props.barChartSettings.barWidth
      })
    }
  }

  handleExpandAll = expand => {
    this.setState({ isOptionsPanelOpen: expand, isCustomizeColorsPanelOpen: expand, isLayoutPanelOpen: expand, isExpandAll: !expand })
  }

  checkExpandAll = () => {
    const { isOptionsPanelOpen, isCustomizeColorsPanelOpen, isLayoutPanelOpen } = this.state
    const isExpandAllState = (isOptionsPanelOpen && isCustomizeColorsPanelOpen && isLayoutPanelOpen)
    this.setState({ isExpandAll: !isExpandAllState })
  }

  handleOptionsPanelExpansionChange = () => {
    this.setState({ isOptionsPanelOpen: !this.state.isOptionsPanelOpen }, () => this.checkExpandAll())
  }

  handleColorPanelExpansionChange = () => {
    this.setState({ isCustomizeColorsPanelOpen: !this.state.isCustomizeColorsPanelOpen }, () => this.checkExpandAll())
  }

  handleLayoutPanelExpansionChange = () => {
    this.setState({ isLayoutPanelOpen: !this.state.isLayoutPanelOpen }, () => this.checkExpandAll())
  }

  handleGridOption = event => {
    this.props.editBarChartSettings({ isGrid: event.target.value, action: true })
  }

  handleNameOrientationOption = event => {
    this.props.editBarChartSettings({ propertyNameOrientation: event.target.value, action: true })
  }

  handleValueOrientationOption = event => {
    this.props.editBarChartSettings({ isValueOrientation: event.target.value, action: true })
  }

  handleColorChange = (color, namespace, flag) => {
    this.props.editBarChartSettings({ [namespace]: color, action: flag })
  }

  handleLayoutOptionChange = (pageTitle, selectedItem) => {
    this.props.editBarChartSettings({ pageTitle, selectedLayoutValue: selectedItem, action: true })
  }

  handleFloorPlanOptions = () => {
    this.props.editBarChartSettings({ isFloorPlan: !this.props.barChartSettings.isFloorPlan, action: true })
  }

  handleSummaryPlanOptions = () => {
    this.props.editBarChartSettings({ isSummaryBarCharts: !this.props.barChartSettings.isSummaryBarCharts, action: true })
  }

  handleFpLayoutOptionChange = (pageTitle, selectedItem) => {
    this.props.editFloorPlanBarChartSettings({ pageTitle, selectedLayoutValue: selectedItem, action: true })
  }

  filterSelectOptionsForHalfBarChart(barChartData, pageTitle, selectOptions) {
    let filteredOptions = [...selectOptions]
    const chartDataObj = barChartData.find(obj => obj.pageTitle === pageTitle)
    const totalProperties = chartDataObj && chartDataObj.chartData.datasets[0].data.length
    if (totalProperties > 8) {
      filteredOptions = selectOptions.filter(layoutOption => layoutOption.value !== 2)
    }

    return filteredOptions
  }

  pixelIncrementDecrementHandler(type) {
    const pixelLimit = [-1, 401]
    const { barWidthvalue } = this.state
    const setPixel = {
      'increment': () => barWidthvalue + 1,
      'decrement': () => barWidthvalue - 1,
      'slider': () => type
    }
    const targetPixelSize = (setPixel[type] || setPixel.slider)()

    if (!pixelLimit.includes(targetPixelSize)) {
      this.setState({ barWidthvalue: targetPixelSize })
      this.props.editBarChartSettings({ barWidth: targetPixelSize, action: true })
    }
  }

  render() {
    const {
      barChartData,
      barChartSettings: { isFloorPlan, isSummaryBarCharts, isGrid, isValueOrientation, subjectPropBarColor, compPropBarColor, wtdAvgLineBarColor, propertyNameOrientation, barChartLayoutOptions, fpbarChartLayoutOptions },
      classes,
      templateName,
      compsWithSubjectProperty
    } = this.props
    const { isOptionsPanelOpen, isCustomizeColorsPanelOpen, isLayoutPanelOpen, barWidthvalue } = this.state
    const selectOptions = [
      {
        label: '1 per page',
        value: 1
      },
      {
        label: '2 per page',
        value: 2
      },
      {
        label: 'Hide',
        value: 0
      }
    ]

    const summarySelectOptions = [
      {
        label: 'Show',
        value: 1
      },
      {
        label: 'Hide',
        value: 0
      }
    ]

    const colorPickerList = [
      {
        name: 'Subject property',
        key: 'subjectPropBarColor',
        defaultColor: subjectPropBarColor
      },
      {
        name: 'Comparable property',
        key: 'compPropBarColor',
        defaultColor: compPropBarColor
      },
      {
        name: 'Average line',
        key: 'wtdAvgLineBarColor',
        defaultColor: wtdAvgLineBarColor
      }
    ]

    if (!compsWithSubjectProperty) {
      colorPickerList.shift()
    }

    return (
      <div className="bar-chart-layout-container">
        <div className="marginLeft-34 summary-scroll bar-chart-tab" data-testid="barchart-settings">
          <div className="bar-chart-title-container">
            <ArrowForwardIos className="arrow-forward" />
            <div className="bar-chart-title">Bar Chart</div>
          </div>
          <div className="bar-chart-customize">
            <div className="customiseTitle">Customize</div>
            {this.state.isExpandAll && <div className="expandTitle" data-testid="expandAll" onClick={() => this.handleExpandAll(true)}>Expand All</div>}
            {!this.state.isExpandAll && <div className="expandTitle" onClick={() => this.handleExpandAll(false)}>Collapse All</div>}
          </div>

          <Accordion className={`${isOptionsPanelOpen ? '' : 'expansion-panel-color-picker'}`} expanded={isOptionsPanelOpen}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              data-testid="optionsExpansionPanel"
              onClick={this.handleOptionsPanelExpansionChange}
            >
              <div className="panel-title">OPTIONS</div>
            </AccordionSummary>
            <AccordionDetails className="expansion-panel" data-testid="optionsExpansionPanelDetails">
              <div className="bar-chart-option border-bottom">
                <div className="panel-title">Grid</div>
                <div className="grid-option">
                  <RadioGroup
                    aria-label="gridOption"
                    name="gridOption"
                    value={isGrid}
                    onChange={this.handleGridOption}
                    row
                  >
                    <div data-testid="grid-option-show" className={classes.root}>
                      <FormControlLabel
                        value="show"
                        control={
                          <Radio
                            checked={isGrid === 'show'}
                            inputProps={{ 'data-testid': 'show_grid' }}
                          />
                        }
                        label="Show"
                      />
                    </div>
                    <div data-testid="grid-option-hide" className={`${classes.root} rigth-opt`}>
                      <FormControlLabel
                        value="hide"
                        control={
                          <Radio
                            checked={isGrid === 'hide'}
                            inputProps={{ 'data-testid': 'hide_grid' }}
                          />
                        }
                        label="Hide"
                      />
                    </div>
                  </RadioGroup>
                </div>
              </div>
              <div className="bar-chart-option border-bottom">
                <div className="panel-title">Property Name Orientation</div>
                <div className="nameOrientation-option">
                  <RadioGroup
                    aria-label="nameOrientationOption"
                    name="nameOrientationOption"
                    value={propertyNameOrientation}
                    onChange={this.handleNameOrientationOption}
                    row
                  >
                    <div data-testid="nameOrientation-option-default" className={classes.root}>
                      <FormControlLabel
                        value="default"
                        control={
                          <Radio
                            checked={propertyNameOrientation === 'default'}
                            inputProps={{ 'data-testid': 'default_orientation' }}
                          />
                        }
                        label="Default"
                      />
                    </div>
                    <div data-testid="nameOrientation-option-tilt" className={`${classes.root} rigth-opt`}>
                      <FormControlLabel
                        value="tilt"
                        control={
                          <Radio
                            checked={propertyNameOrientation === 'tilt'}
                            inputProps={{ 'data-testid': 'tilt_orientation' }}
                          />
                        }
                        label="Tilt"
                      />
                    </div>
                  </RadioGroup>
                </div>
              </div>
              <div className="bar-chart-option border-bottom">
                <div className="panel-title">Property Value Orientation</div>
                <div className="valueOrientation-option">
                  <RadioGroup
                    aria-label="valueOrientationOption"
                    name="valueOrientationOption"
                    value={isValueOrientation}
                    onChange={this.handleValueOrientationOption}
                    row
                  >
                    <div data-testid="valueOrientation-option-horizontal" className={classes.root}>
                      <FormControlLabel
                        value="show"
                        control={
                          <Radio
                            checked={isValueOrientation === 'show'}
                            inputProps={{ 'data-testid': 'horizontal_valueOrientation' }}
                          />
                        }
                        label="Show"
                      />
                    </div>
                    <div data-testid="valueOrientation-option-hide" className={`${classes.root} rigth-opt`}>
                      <FormControlLabel
                        value="hide"
                        control={
                          <Radio
                            checked={isValueOrientation === 'hide'}
                            inputProps={{ 'data-testid': 'hide_valueOrientation' }}
                          />
                        }
                        label="Hide"
                      />
                    </div>
                  </RadioGroup>
                </div>
              </div>
              <div className="bar-chart-option">
                <div className="panel-title">Bar Width</div>
                <div>
                  <div className="bar-chart-slider">
                    <div className="slider-value">
                      <span data-testid="bar-chart-slider-value">{`${barWidthvalue} pt`}</span>
                    </div>
                    <div className="slider-buttons">
                      <IndeterminateCheckBoxIcon data-testid="bar-width-decrement" className="slider-icons" onClick={() => this.pixelIncrementDecrementHandler('decrement')}/>
                      <AddBoxIcon data-testid="bar-width-increment" className="slider-icons" onClick={() => this.pixelIncrementDecrementHandler('increment')}/>
                    </div>
                  </div>
                  <div className="slider-styles">
                    <Slider
                      value={barWidthvalue}
                      onChange={value => this.pixelIncrementDecrementHandler(value)}
                      max={250}
                      defaultValue={40}
                      railStyle={{ backgroundColor: '#C7C4C4', height: 3 }}
                      trackStyle={{ backgroundColor: 'rgb(0, 112, 175)', height: 3 }}
                      handleStyle={{
                        borderColor: 'rgb(0, 112, 175)'
                      }}
                    />
                  </div>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion className={`${isCustomizeColorsPanelOpen ? '' : 'expansion-panel-color-picker'}`} expanded={isCustomizeColorsPanelOpen}>
            <div className={classes.expansionTitle}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                data-testid="colorsExpansionPanel"
                onClick={this.handleColorPanelExpansionChange}
              >
                <div className="panel-title">CUSTOMIZE COLORS</div>
              </AccordionSummary>
            </div>
            <AccordionDetails data-testid="colorsExpansionPanelDetails">
              <div className="bar-chart-option">
                {colorPickerList.map((obj, index) => (
                  <div key={index} className="custom-color-row">
                    <ColorPicker colorPickerObj={obj} displayLeft={Boolean(index % 2)} handleColorChange={this.handleColorChange} />
                  </div>
                ))
                }
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion className={`${isLayoutPanelOpen ? '' : 'expansion-panel-color-picker'}`} expanded={isLayoutPanelOpen}>
            <div className={classes.expansionTitle}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                data-testid="layoutExpansionPanel"
                onClick={this.handleLayoutPanelExpansionChange}
              >
                <div className="panel-title">LAYOUT OPTION</div>
              </AccordionSummary>
            </div>
            <AccordionDetails>
              <div className="bar-chart-option" data-testid="layoutExpansionPanelDetails">
                <div>
                  <div className="floor_plan">
                    <div className="panel-title">SUMMARY BAR CHARTS</div>
                    <div>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={isSummaryBarCharts}
                            onChange={this.handleSummaryPlanOptions}
                            name="showSummaryBarCharts"
                            color="primary"
                            inputProps={{ 'data-testid': 'showSummaryBarCharts_switch' }}
                          />
                        }
                        label="show"
                        labelPlacement="start"
                      />
                    </div>
                  </div>
                  {barChartLayoutOptions && barChartLayoutOptions.map((layoutObj, index) => (
                    <div key={`${layoutObj.layout}-${index}`} className="layout-option-row" data-testid="layout-option-container">
                      <span className="option-name">{layoutObj.pageTitle}</span>
                      <Select
                        inputProps={{ 'data-testid': 'select_menu_item' }}
                        title={layoutObj.pageTitle}
                        selectOptions={this.filterSelectOptionsForHalfBarChart(barChartData, layoutObj.pageTitle, selectOptions)}
                        defaultOption={layoutObj.layout.toString()}
                        handleSelect={selectedItem => this.handleLayoutOptionChange(layoutObj.pageTitle, selectedItem)}
                        disabled={!isSummaryBarCharts}
                      />
                    </div>
                  ))}
                </div>
                {!templateName.includes(SALES_COMPARABLES) && fpbarChartLayoutOptions &&
                  <>
                    <div className="divider"></div>
                    <div>
                      <div className="floor_plan">
                        <div className="panel-title">FLOOR PLAN</div>
                        <div>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isFloorPlan}
                                onChange={this.handleFloorPlanOptions}
                                name="showFloorPlans"
                                color="primary"
                                inputProps={{ 'data-testid': 'showFloorPlans_switch' }}
                              />
                            }
                            label="show"
                            labelPlacement="start"
                          />
                        </div>
                      </div>
                      {fpbarChartLayoutOptions && fpbarChartLayoutOptions.map((layoutObj, index) => (
                        <div key={`${layoutObj.layout}-${index}`} className="layout-option-row" data-testid="layout-option-container">
                          <span className="option-name">{layoutObj.pageTitle}</span>
                          <Select
                            index={index}
                            inputProps={{ 'data-testid': 'select_menu_item' }}
                            title={layoutObj.pageTitle}
                            selectOptions={this.filterSelectOptionsForHalfBarChart(barChartData, layoutObj.pageTitle, layoutObj.pageTitle.includes('Summary') ? summarySelectOptions : selectOptions)}
                            defaultOption={layoutObj.layout.toString()}
                            handleSelect={selectedItem => this.handleFpLayoutOptionChange(layoutObj.pageTitle, selectedItem)}
                            disabled={!isFloorPlan}
                          />
                        </div>
                      ))}
                    </div>
                  </>}
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    )
  }
}

BarChartSettings.propTypes = {
  templateName: PropTypes.string,
  editFloorPlanBarChartSettings: PropTypes.func,
  editBarChartSettings: PropTypes.func,
  barChartSettings: PropTypes.shape({
    isFloorPlan: PropTypes.bool,
    isSummaryBarCharts: PropTypes.bool,
    isGrid: PropTypes.string,
    isValueOrientation: PropTypes.string,
    subjectPropBarColor: PropTypes.string,
    compPropBarColor: PropTypes.string,
    wtdAvgLineBarColor: PropTypes.string,
    barChartLayoutOptions: PropTypes.array,
    barWidth: PropTypes.number
  }),
  classes: PropTypes.object,
  barChartData: PropTypes.array,
  compsWithSubjectProperty: PropTypes.bool
}

const mapStateToProps = state => ({
  templateName: Comps.selectors.comps.templateName(state),
  barChartSettings: Comps.selectors.comps.barChartSettings(state),
  barChartData: Comps.selectors.comps.barChartData(state),
  compsWithSubjectProperty: Comps.selectors.comps.compsWithSubjectProperty(state)
})

const mapDispatchToProps = {
  editBarChartSettings: Comps.actions.editBarChartSettings,
  editFloorPlanBarChartSettings: Comps.actions.editFloorPlanBarChartSettings
}

export default withStyles(useStyles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(BarChartSettings))
